import _ from 'lodash'
import { UserGameHandState } from '../sharedBetweenServerAndClient__DO_NOT_EDIT/AbstractGameHandController/buildUserGameHandStates'
import { captureExceptionWithLabel } from '../utils/sentry'

const _computeDisplayedTablePots = (userStates: UserGameHandState[]) => {
  const userStatesGroupedByAmountInvested = _.map(
    _.groupBy(userStates, (state) => state.amountInvestedInPreviousRounds),
    (states, amountInvested) => ({
      states,
      individualAmountInvested: parseInt(amountInvested, 10),
      totalAmountInvested: parseInt(amountInvested, 10) * states.length,
    }),
  )
  userStatesGroupedByAmountInvested.sort(
    (group1, group2) => group1.individualAmountInvested - group2.individualAmountInvested,
  )
  const pots: number[] = []
  userStatesGroupedByAmountInvested.forEach(
    ({ states, totalAmountInvested: amountInvested }, index) => {
      if (states.every((state) => state.state === 'FOLDED' || state.state === 'OUT')) {
        userStatesGroupedByAmountInvested[index + 1].totalAmountInvested += amountInvested
      } else {
        pots.push(amountInvested)
      }
    },
  )
  return pots
}

export const computeDisplayedTablePots = (userStates: UserGameHandState[]): number[] => {
  try {
    return _computeDisplayedTablePots(userStates)
  } catch (e) {
    captureExceptionWithLabel(e, 'computeDisplayedTablePots')
    return []
  }
}
